import { Pagination, Stack } from '@mui/material';

import usePosts from '@/hooks/contentful/usePosts';

import type React from 'react';

interface PaginationArticlesProps {
  search?: string;
  limit?: number;
  skip?: number;
  actualPage: number;
  filter?: Record<string, string>;
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const PaginationArticles = ({
  search,
  limit = 6,
  skip,
  actualPage,
  filter,
  handleChangePage,
}: PaginationArticlesProps) => {
  const { totalPosts } = usePosts(search, skip, limit, filter);

  const count = totalPosts / limit;

  return (
    <Stack alignItems={'center'} margin={'1rem 0'}>
      <Pagination
        count={Math.ceil(count)}
        color="primary"
        page={actualPage}
        onChange={handleChangePage}
      />
    </Stack>
  );
};

export default PaginationArticles;
